
import { Component, Vue, Prop } from 'vue-property-decorator';
import { mainStore, companyStore, juridicoStore, checkoutStore } from '@/store';
import _ from 'lodash';
import api from '@/api';

@Component
export default class UploadFilesCheckout extends Vue {
  @Prop({ type: String, default: '' }) readonly propTableName: string;
  @Prop({ type: Number, default: 0 }) readonly propTableId;
  @Prop({ type: Boolean, default: false }) readonly fileZip: boolean;
  @Prop({ type: Number, default: 0 }) readonly propUserCreate;
  @Prop({ type: Number, default: 0 }) readonly propState;

  isLoading = false;
  isLoadingBtn = false;
  ocorrencia_files = [];
  files: any = [];
  modelFiles = [];
  temFile = false;
  selectFilesError = false;

  header = [
    {
      text: 'Nome do Arquivo',
      value: 'blob.name',
      align: 'left',
    },
    {
      text: 'Tamanho do arquivo',
      value: 'blob.size',
      align: 'left',
    },
    {
      text: 'Criado em',
      value: 'blob.created',
      align: 'left',
    },
    {
      text: 'Ações',
      value: 'actions',
      align: 'left',
    },
  ];

  get currentUser() {
    return mainStore.userProfile;
  }

  get isFranchise() {
    return this.currentUser.company.is_franchise === false;
  }

  selectFile() {
    this.files = [];
    this.selectFilesError = false;
    const maxSize = 4 * Math.pow(10, 8);

    this.temFile = false;
    let error = false;
    //@ts-ignore
    if (this.modelFiles && this.modelFiles.size > maxSize) {
      error = true;
      this.selectFilesError = true;
    }
    this.files.push({
      file: this.modelFiles,
      uploaded: false,
      sizeError: error,
    });
    this.temFile = true;
  }

  openDownloadLink(item: any) {
    var element = document.createElement('a');
    element.setAttribute('href', item['download_url']);
    if (
      item['blob']['full_name'].includes('pdf') ||
      item['blob']['full_name'].includes('png') ||
      item['blob']['full_name'].includes('jpg') ||
      item['blob']['full_name'].includes('jpeg')
    ) {
      element.setAttribute('target', '_blank');
    } else {
      element.setAttribute('style', 'display:none;');
    }
    element.click();
    element.remove();
  }

  formatSize(size: any) {
    if (size < 1000) {
      return `${(size / 1).toFixed(0)} B`;
    } else if (size / Math.pow(10, 3) < 1000) {
      return `${(size / Math.pow(10, 3)).toFixed(2)} Kb`;
    } else if (size / Math.pow(10, 6) < 1000) {
      return `${(size / Math.pow(10, 6)).toFixed(2)} Mb`;
    } else if (size / Math.pow(10, 9) < 1000) {
      return `${(size / Math.pow(10, 9)).toFixed(2)} Gb`;
    }
  }

  async handleUploadFile() {
    this.$swal({
      title: 'Confirma o envio do arquivo?',
      text: 'Certifique-se de enviar um arquivo válido.',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, eu confirmo!',
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        this.isLoadingBtn = true;

        let response = await checkoutStore.uploadFilesCheckout({
          files: this.files,
          bucket_name: 'checkout',
          file_name: this.propTableName,
          file_id: this.propTableId,
        });

        this.$swal({
          title: 'Obtendo arquivos...',
          text: 'Por favor, aguarde.',
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading();
          },
        });

        this.ocorrencia_files = await checkoutStore.getFilesCheckout({
          table_name: this.propTableName,
          id: this.propTableId,
        });

        this.$swal.close();

        if (response) {
          this.$swal.fire('Upload do arquivo realizado com sucesso!', '', 'success');
          this.modelFiles = [];
        } else {
          this.$swal.fire('Falha ao enviar o arquivo.', 'Tente novamente!', 'error');
        }

        this.isLoadingBtn = false;
      }
      this.$emit('getPropState', Math.floor(Math.random() * 200));
    });
  }

  handleDeleteArquivo(item: any) {
    this.$swal({
      title: 'Confirma a exclusão do Arquivo?',
      text: 'Após a confirmação não será possível recuperar o arquivo.',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, eu confirmo!',
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        this.isLoadingBtn = true;
        let res = await api.deleteObjectFromBucket(mainStore.token, 'checkout', item.blob.full_name);
        if (res) {
          this.$swal.fire('Arquivo', 'Excluído com sucesso', 'success');
        } else {
          this.$swal.fire('Arquivo', 'Falha ao excluir, tente novamente', 'error');
        }
        this.ocorrencia_files = await checkoutStore.getFilesCheckout({
          table_name: this.propTableName,
          id: this.propTableId,
        });
        this.isLoadingBtn = false;
      }
      this.$emit('getPropState', Math.floor(Math.random() * 200));
    });
  }

  public async mounted() {
    this.isLoading = true;
    this.ocorrencia_files = await checkoutStore.getFilesCheckout({
      table_name: this.propTableName,
      id: this.propTableId,
    });
    this.isLoading = false;
  }
}
